export default function getResource() {
    return {
        top: 'Top',
        details: 'Details',
        similar: 'Similar',
        qAndA: 'Q&A',
        reviews: 'Reviews',
        navLabel: 'Product page navigation'
    };
}
